<template>
    <q-modal v-model="show_report" :content-css="{ minWidth: '100vw', minHeight: '100vh' }" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
                <q-toolbar-title> {{ id }} - {{ title }} </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <q-tabs v-model="tab" color="secondary" class="shadow-1">
                    <q-tab slot="title" name="certificates" icon="fal fa-file-certificate" :label="$t('certificates')" />
                    <q-tab slot="title" name="events" icon="fal fa-calendar-check" :label="$t('events')" />
                    <q-tab slot="title" name="registrations" icon="fal fa-ballot-check" :label="$t('registrations')" />
                    <q-tab slot="title" name="availables" icon="fal fa-users" :label="$t('availables')" />
                    <q-tab slot="title" name="support_material" icon="fal fa-download" :label="$t('support_material')" />
                    <q-tab slot="title" name="reaction_tests" icon="fal fa-clipboard-list-check" :label="$t('reaction_tests')" />
                    <q-tab slot="title" name="stars" icon="fal fa-star" :label="$t('comments')" />

                    <q-tab-pane name="certificates" class="q-px-lg q-pb-xl" keep-alive>
                        <certificates :load="tab === 'certificates' && show_report_presential ? true : false" :status="status" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="events" class="q-px-lg q-pb-xl" keep-alive>
                        <events :load="tab === 'events' && show_report_presential ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="registrations" class="q-px-lg q-pb-xl" keep-alive>
                        <registrations :load="tab === 'registrations' && show_report_presential ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="availables" class="q-px-lg q-pb-xl" keep-alive>
                        <availables :load="tab === 'availables' && show_report_presential ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="support_material" class="q-px-lg q-pb-xl" keep-alive>
                        <support-material :load="tab === 'support_material' && show_report_presential ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="reaction_tests" class="q-px-lg q-pb-xl" keep-alive>
                        <reaction-test :load="tab === 'reaction_tests' && show_report_presential ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="stars" class="q-px-lg q-pb-xl" keep-alive>
                        <comments :load="tab === 'stars' && show_report_presential ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>
                </q-tabs>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import Certificates from 'components/admin/presential/report/Certificates.vue'
import Events from 'components/admin/presential/report/Events.vue'
import Registrations from 'components/admin/presential/report/Registrations.vue'
import Availables from 'components/admin/presential/report/Availables'
import SupportMaterial from 'components/admin/presential/report/SupportMaterial.vue'
import ReactionTest from 'components/admin/presential/report/ReactionTest.vue'
import Comments from 'components/admin/presential/report/Comments'

export default {
    name: 'AdminPresentialReports',

    props: ['show_report_presential', 'id', 'status', 'title', 'permissions'],

    components: {
        certificates: Certificates,
        events: Events,
        registrations: Registrations,
        availables: Availables,
        'support-material': SupportMaterial,
        'reaction-test': ReactionTest,
        comments: Comments
    },

    data() {
        return {
            tab: 'certificates'
        }
    },

    computed: {
        show_report: {
            get() {
                return this.show_report_presential
            },
            set() {
                this.$emit('hide_report', '')
                this.tab = 'certificates'
            }
        }
    }
}
</script>

<style></style>
